<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-title">
        <img :src="$brand.logoUrl" alt="" class="login-logo">
        <h1>{{ $brand.loginTitle }}</h1>
        <p>{{ $brand.companyName }} · 企业人力资源管理平台</p>
      </div>
      <el-form :rules="rules" :model="staff" ref="loginForm" class="login-form">
        <el-form-item prop="code">
          <el-input
            size="medium"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
            v-model.trim="staff.code"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            size="medium"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            v-model.trim="staff.password"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-button type="primary" class="login-button" @click="handleLogin">登 录</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import { login } from '../../api/login'

export default {
  name: 'Login',
  data () {
    return {
      staff: {},
      // 效验规则
      rules: {
        code: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在3到10个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在3到10个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          login(this.staff).then(
            response => {
              if (response.code === 200) {
                this.$store.commit('staff/SET_STAFF', response.data) // 存储用户信息
                this.$store.commit('token/SET_TOKEN', response.token) // 存储token
                this.$message.success('登录成功！')
                this.$router.push({
                  path: '/home'
                })
              } else {
                this.$message.error(response.message)
              }
            }
          )
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.login-page {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 100vh;
  padding-right: 12%;
  background:
    linear-gradient(90deg, rgba(5, 18, 45, 0.18), rgba(5, 18, 45, 0.58)),
    url("../../assets/bg2.jpg") center/cover no-repeat;
}

.login-card {
  width: 400px;
  padding: 46px 42px 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18);
}

.login-title {
  margin-bottom: 34px;
  text-align: center;
}

.login-logo {
  width: 44px;
  height: 44px;
  margin-bottom: 14px;
  object-fit: contain;
}

.login-title h1 {
  margin: 0;
  color: #1f2d3d;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 1px;
}

.login-title p {
  margin: 12px 0 0;
  color: #7a8594;
  font-size: 14px;
}

.login-form /deep/ .el-input__inner {
  height: 46px;
  border-radius: 4px;
}

.login-form /deep/ .el-form-item {
  margin-bottom: 22px;
}

.login-button {
  width: 100%;
  height: 46px;
  margin-top: 8px;
  border: none;
  border-radius: 4px;
  background: #123b7a;
  font-size: 16px;
  letter-spacing: 6px;
}

.login-button:hover,
.login-button:focus {
  background: #1d4f9a;
}

@media (max-width: 768px) {
  .login-page {
    justify-content: center;
    padding: 24px;
  }

  .login-card {
    width: 100%;
    max-width: 400px;
  }
}
</style>
